export class EnumType {
  constructor() {
    throw new Error('Enum types are not to be instantiated.');
  }
}
